import { ANALYSIS_TERMINAL_STATUSES } from '../models/analysis.types'
import { decodeCreativeLabellingProgress } from '../models/creativeAi.codec'
import { LABELLING_TERMINAL_STATUSES } from '../models/labelling.types'
import type { CreativeLabellingProgressEvent, LabellingFrameKind } from '../models/labelling.types'

const ANALYSIS_TERMINAL: ReadonlySet<string> = new Set(ANALYSIS_TERMINAL_STATUSES)
const RELABEL_TERMINAL: ReadonlySet<string> = new Set(LABELLING_TERMINAL_STATUSES)

export function parseLabellingFrame(raw: unknown): CreativeLabellingProgressEvent | null {
  try {
    return decodeCreativeLabellingProgress(raw)
  } catch {
    return null
  }
}

/** Backend-published discriminator; never infer a kind from id/analyses structure. */
export function classifyLabellingFrame(frame: CreativeLabellingProgressEvent): LabellingFrameKind {
  return frame.run_type === 'relabel' ? 'relabel' : 'analysis'
}

export function isTerminalLabellingFrame(frame: CreativeLabellingProgressEvent): boolean {
  return frame.run_type === 'relabel'
    ? RELABEL_TERMINAL.has(frame.status)
    : ANALYSIS_TERMINAL.has(frame.status)
}

function eventIdParts(eventId: string): readonly [number, number] | null {
  const [milliseconds, sequence, ...rest] = eventId.split('-')
  if (rest.length > 0 || milliseconds === undefined || sequence === undefined) return null
  const parsedMilliseconds = Number(milliseconds)
  const parsedSequence = Number(sequence)
  return Number.isFinite(parsedMilliseconds) && Number.isFinite(parsedSequence)
    ? [parsedMilliseconds, parsedSequence]
    : null
}

export function isNewerLabellingFrame(
  incoming: CreativeLabellingProgressEvent,
  applied: CreativeLabellingProgressEvent | undefined,
): boolean {
  if (!applied || incoming.id !== applied.id) return true
  if (incoming.event_id && applied.event_id) {
    const incomingParts = eventIdParts(incoming.event_id)
    const appliedParts = eventIdParts(applied.event_id)
    if (incomingParts && appliedParts) {
      return incomingParts[0] !== appliedParts[0]
        ? incomingParts[0] > appliedParts[0]
        : incomingParts[1] > appliedParts[1]
    }
  }
  return incoming.ts > applied.ts
}
